<template>
  <div>
    <material-card
      :title="title"
      data-testId="material-card-title"
      color="dover-blue">
      <v-flex
        v-if="progressBar.loading"
        xs12
        md6
        lg6>
        <span data-testId="span-progressBar-label">{{ progressBar.label }}</span>
        <MaglinkComponentLoadingBar
          :loading="progressBar.loading"
          :indeterminate="false"
          :max-value="progressBar.maxValue"
          :value="progressBar.currentValue"
          data-testId="MaglinkComponentLoadingBar" />
      </v-flex>
      <v-flex
        xs12
        md12
        lg12>
        <span
          data-testId="span-Tanks"
          class="caption grey--text font-weight-bold">
          {{ $t('Tanks/probes') }}
        </span>
        <hr>
      </v-flex>
      <v-data-table
        :headers="headersProbes"
        :items="probeData"
        :no-data-text="`${ Maglink.NoDataMessage(false) }`"
        :no-results-text="`${ Maglink.NoDataMessage(true) }`"
        data-testId="data-table"
        hide-actions>
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            data-testId="span-header-text"
            class="dover-light-blue-color"
            v-text="header.text"/>
        </template>
        <template
          slot="items"
          slot-scope="{ item }">
          <td>{{ item.name }}</td>
          <td>{{ item.serial }}</td>
          <td>{{ item.softwareVersion }}</td>
          <td>{{ item.modelName }}</td>
          <td/>
        </template>
      </v-data-table>
      <v-flex
        xs12
        md12
        lg12>
        <span
          data-testId="span-Sensors"
          class="caption grey--text font-weight-bold">
          {{ $t('Sensors') }}
        </span>
        <hr>
      </v-flex>
      <v-data-table
        :headers="headersSensors"
        :items="sensorData"
        :no-data-text="`${ Maglink.NoDataMessage(false) }`"
        :no-results-text="`${ Maglink.NoDataMessage(true) }`"
        data-testId="data-table-2"
        hide-actions>
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            data-testId="span-header-text-2"
            class="dover-light-blue-color"
            v-text="header.text"/>
        </template>
        <template
          slot="items"
          slot-scope="{ item }">
          <td>{{ item.name }}</td>
          <td>{{ item.serial }}</td>
          <td>{{ item.softwareVersion }}</td>
          <td>{{ item.modelName }}</td>
        </template>
      </v-data-table>
      <v-flex
        v-if="otherData.length > 0"
        xs12
        md12
        lg12>
        <span
          data-testId="span-Other-devices"
          class="caption grey--text font-weight-bold">
          {{ $t('Other devices') }}
        </span>
        <hr>
      </v-flex>
      <v-data-table
        v-if="otherData.length > 0"
        :headers="headersOthers"
        :items="otherData"
        :no-data-text="`${ Maglink.NoDataMessage(false) }`"
        :no-results-text="`${ Maglink.NoDataMessage(true) }`"
        data-testId="data-table-headers-Others"
        hide-actions>
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            data-testId="span-header-text-3"
            class="dover-light-blue-color"
            v-text="header.text"/>
        </template>
        <template
          slot="items"
          slot-scope="{ item }">
          <td>{{ item.name }}</td>
          <td>{{ item.number }}</td>
          <td>{{ item.softwareVersion }}</td>
          <td/>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    tanks: undefined,
    sensors: undefined,
    probeData: [],
    sensorData: [],
    otherData: [],
    headersProbes: [
      { sortable: false, text: i18n.t('Name') },
      { sortable: false, text: i18n.t('Serial number') },
      { sortable: false, text: i18n.t('Firmware version') },
      { sortable: false, text: i18n.t('Model') }
    ],
    headersSensors: [
      { sortable: false, text: i18n.t('Name') },
      { sortable: false, text: i18n.t('Serial number') },
      { sortable: false, text: i18n.t('Firmware version') },
      { sortable: false, text: i18n.t('Model') }
    ],
    headersOthers: [
      { sortable: false, text: i18n.t('Name') },
      { sortable: false, text: i18n.t('Number') },
      { sortable: false, text: i18n.t('Firmware version') },
      { sortable: false, text: '' }
    ],
    commandQueue: [],
    commandIsActive: false,
    currentToken: undefined,
    currentCommand: undefined,
    mainTimerId: 0,
    responseTimerId: 0,
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0,
      tickId: 0,
      label: ''
    }
  }),
  mounted () {
    this.Maglink.GetTanks()
      .then(response => {
        this.tanks = response.data
        for (var i = 0; i < this.tanks.length; i++) {
          this.addTank(this.tanks[i])
        }

        this.Maglink.GetSensors()
          .then(response => {
            this.sensors = response.data
            for (var i = 0; i < this.sensors.length; i++) {
              this.addSensor(this.sensors[i])
            }

            this.startMainTimer(200)
            if (Vue.prototype.Maglink.isPlus) {
              this.getDetectedDevices()
            }
          })
          .catch(error => (this.snack('error', error.message)))
      })
      .catch(error => (this.snack('error', error.message)))
  },
  beforeDestroy () {
    this.clearTimers()
  },
  methods: {
    isPBProbe (tank) {
      return (tank.probeType === 12 || tank.probeType === 13 || tank.probeType === 14)
    },
    isPBSensor (sensor) {
      return (sensor.sensorType > 3)
    },
    addTank (tank) {
      this.probeData.push({ number: tank.tankNumber, name: ' ' + tank.tankNumber + ' - ' + tank.tankDescription, serial: tank.serial, softwareVersion: '' })
      if (!this.isPBProbe(tank)) {
        this.addCommand_V_toQueue(tank.tankNumber, tank.serial)
      }
    },
    addSensor (sensor) {
      this.sensorData.push({ number: sensor.sensorNumber, name: ' ' + sensor.sensorNumber + ' - ' + sensor.sensorName, serial: sensor.serial, softwareVersion: '' })
    },
    updateFirmwareVersion (serialNumber, firmware) {
      if (serialNumber === undefined || serialNumber.length < 1) {
        return
      }
      for (var i = 0; i < this.probeData.length; i++) {
        if (this.probeData[i].serial === serialNumber) {
          this.probeData[i].softwareVersion = firmware
        }
      }
    },
    getDetectedDevices () {
      this.Maglink.GetAutodetections()
        .then(response => {
          response.data.forEach(item => {
            if (item.device === 80 && item.serial !== '0') { // PROBE
              var bExist = false
              for (var i = 0; i < this.probeData.length; i++) {
                if (this.Maglink.PadRight(this.probeData[i].serial, 10) === this.Maglink.PadRight(item.serial, 10)) {
                  this.probeData[i].softwareVersion = (item.softwareVersion * 0.01).toFixed(2)
                  this.probeData[i].modelName = item.modelName
                  bExist = true
                }
              }
              if (!bExist) {
                this.probeData.push({ number: 0, name: '', serial: item.serial, softwareVersion: (item.softwareVersion * 0.01).toFixed(2), modelName: item.modelName })
              }
            }

            if (item.device === 83 && item.serial !== '0') { // ISIM
              bExist = false
              for (i = 0; i < this.sensorData.length; i++) {
                if (this.sensorData[i].serial === item.serial) {
                  this.sensorData[i].softwareVersion = (item.softwareVersion * 0.01).toFixed(2)
                  this.sensorData[i].modelName = item.modelName + ' ' + item.description
                  bExist = true
                }
              }
              if (!bExist) {
                this.sensorData.push({ number: 0, name: '', serial: item.serial, softwareVersion: (item.softwareVersion * 0.01).toFixed(2), modelName: item.modelName + ' ' + item.description })
              }
            }

            if (item.device === 65 && item.moduleAddress !== '0') { // PB
              this.otherData.push({ number: item.moduleAddress, name: this.$t('PB board'), serial: '', softwareVersion: (item.softwareVersion * 0.01).toFixed(2), modelName: '' })
            }
            if (item.device === 112 && item.moduleAddress !== '0') { // LIM
              this.otherData.push({ number: item.moduleAddress, name: this.$t('LIM'), serial: '', softwareVersion: (item.softwareVersion * 0.01).toFixed(2), modelName: '' })
            }
            if (item.device === 86 && item.moduleAddress !== '0') { // VSmart
              this.otherData.push({ number: item.moduleAddress, name: this.$t('VSmart'), serial: '', softwareVersion: (item.softwareVersion * 0.01).toFixed(2), modelName: '' })
            }
          })
        })
        .catch(error => (this.snack('error', error.message)))
    },
    addCommand_V_toQueue (tankNumber, serialNumber) {
      // read version
      this.addCommandToQueue('V', 'V' + this.Maglink.PadRight(serialNumber, 5) + '{CR}', this.$t('Firmware'), tankNumber, serialNumber)
    },
    addCommandToQueue (commandType, cmdString, cmdDescription, tankNumber, serialNumber) {
      // intentionally removed, firmware version is available in detection database, the following command could be used in the future for further diagnostic
      // this.commandQueue.push({ cmdType: commandType, cmdText: cmdString, cmdDesc: cmdDescription, tankNumber: tankNumber, serialNumber: serialNumber, processing: false })
    },

    clearTimers () {
      // just to be sure
      this.commandIsActive = false

      this.stopMainTimer()
      this.stopProgressBarTimer()
    },
    stopProgressBarTimer () {
      clearInterval(this.progressBar.tickId)
      this.progressBar.tickId = 0
      this.progressBar.loading = false
      this.progressBar.currentValue = 0
      this.progressBar.label = ''
    },
    startProgressBarTimer () {
      // manage progressbar to show user to wait
      if (this.progressBar.tickId === 0) {
        this.progressBar.label = this.$t('Awaiting for probe response...')
        this.progressBar.loading = true
        this.progressBar.currentValue = 0
        this.progressBar.tickId = setInterval(this.progressBarTick, 100)
      }
    },
    startMainTimer (msecs) {
      if (msecs === undefined) {
        msecs = 5000
      }

      this.mainTimerId = setTimeout(this.sendCommandTimerTick, msecs)
    },
    startResponseTimer (msecs) {
      this.responseTimerId = setTimeout(this.sendResponseCommandTimerTick, msecs)
    },
    stopMainTimer () {
      clearInterval(this.mainTimerId)
      this.mainTimerId = 0
    },
    progressBarTick () {
      if (this.progressBar.currentValue >= this.progressBar.maxValue) this.progressBar.currentValue = 0
      this.progressBar.currentValue += 1
      this.progressBar.label = this.$t('Awaiting for probe response \'{0}\' command', [ this.currentCommand.cmdDesc ])
    },
    sendCommandTimerTick () {
      // no command to process
      if (this.commandQueue.length === 0) {
        this.stopProgressBarTimer()
        return
      }

      this.startProgressBarTimer()

      // current command
      this.currentCommand = this.commandQueue[0]

      // CREATING COMMAND TO SEND
      this.currentToken = this.Maglink.GetToken(this.currentCommand.serialNumber, this.currentCommand.tankNumber, this.currentCommand.cmdType, this.currentCommand.cmdText)

      // SENDING QUESTION COMMAND NOW
      this.Maglink.SendProbeCommand(this.currentToken.command.serial, this.currentToken.command.text)
        .then(response => {
          // get token
          this.currentToken.response.id = response.data.token

          // delete because processed
          this.commandQueue.shift()

          this.currentToken.retry = 0
          this.startResponseTimer(2000)
        })
        .catch(error => {
          this.commandQueue.shift()

          this.currentToken.failCounter += 1
          this.currentToken.response.errorCode = 1000
          this.currentToken.response.errorMsg = error.message

          this.snack('error', this.currentToken.command.type + ' --> ' + error.message)
          this.startMainTimer(1000)
        })
    },
    sendResponseCommandTimerTick () {
      // no command to process
      if (this.currentToken === undefined) {
        return
      }

      // read response
      this.Maglink.GetProbeResponse(this.currentToken.command.serial, this.currentToken.response.id)
        .then(response => {
          this.currentToken.response.text = response.data.response
          this.currentToken.response.status = response.data.completed

          // command has been processed successfully
          if (this.currentToken.response.status) {
            if (this.currentToken.response.text.length < 1 || this.currentToken.response.text === ' ') {
              // this.snack('error', this.$t('no probe response'))
            }
            this.decodeProbeResponse(this.currentToken)
            if (this.currentToken.response.errorCode !== 0) {
              this.snack('error', this.currentToken.command.text + ' --> ' + this.currentToken.response.errorMsg)
            }
            this.startMainTimer(200)
          } else {
            this.currentToken.retry += 1
            if (this.currentToken.retry > 15) {
              this.startMainTimer(200)
              // this.snack('error', this.$t('no probe response'))
            } else {
              this.startResponseTimer(2000)
            }
          }
        })
        .catch(error => {
          this.currentToken.failCounter += 1
          this.currentToken.response.errorCode = 1000
          this.currentToken.response.errorMsg = error.message
          this.snack('error', this.currentToken.command.text + ' --> ' + error.message + ' (' + this.currentToken.failCounter + ')')
          this.startMainTimer(1000)
        })
    },
    decodeProbeResponse (token) {
      // response structure is based upon the command type
      token = this.Maglink.DecodeProbeResponse(token)
      // check for errors
      if (token.response.errorCode !== 0) return

      if (token.command.type === 'V') {
        this.updateFirmwareVersion(token.command.serial, token.response.values.firmware)
      }
    },

    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
